import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error("Authentication failed - no session");
          navigate('/');
          return;
        }

        // Exchange session_id for user data
        const formData = new FormData();
        formData.append('session_id', sessionId);

        const response = await axios.post(`${API}/auth/google/session`, formData);

        if (response.data.success && response.data.user) {
          const userData = response.data.user;
          
          // Store session token
          localStorage.setItem('session_token', userData.session_token);
          localStorage.setItem('user', JSON.stringify(userData));
          
          toast.success(`Welcome, ${userData.name}!`);
          
          // Call onLogin to update App state
          if (onLogin) {
            onLogin(userData);
          }
          
          // Navigate to dashboard
          navigate('/dashboard', { replace: true });
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Google auth error:', error);
        toast.error(error.response?.data?.detail || "Google login failed");
        navigate('/');
      }
    };

    processGoogleAuth();
  }, [location, navigate, onLogin]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Signing you in with Google...</p>
      </div>
    </div>
  );
}
